// extracted by mini-css-extract-plugin
module.exports = {"popover":"PopoverContent_popover__3ULr2","renderedLink":"PopoverContent_renderedLink__1cjlf"};